import { IMinUserDepricated, IValueLabel } from "@mctypes/global.types";
import { IRegister } from "@mctypes/register.types";
import { Button, Group, Paper, Stack, Text, Title } from "@mantine/core";
import React from "react";
import { TitleWithValue } from "..";
import CheckOrWarn from "../CheckOrWarn";
import DropdownEditDepricated from "../DropdownEditDepricated";

const GeneralSettingsCard: React.FC<{
  board: IRegister.BoardPopulated;
  saveCb: <K extends keyof IRegister.BoardPopulated, V>(
    board: IRegister.BoardPopulated,
    prop: K,
    oldValue: V,
    newValue: V,
  ) => void;
  allUsers: IMinUserDepricated[];
  statuses: IValueLabel[];
  hideAccess?: boolean;
  useIsValid: boolean;
  isValid?: boolean;
  canStart?: boolean;
  startNow?: () => void;
}> = ({ board, saveCb, allUsers, statuses, isValid, canStart, startNow, hideAccess = false, useIsValid }) => {
  const getLabel = (value: string) => {
    return statuses.find((status) => status.value === value).label;
  };

  return (
    <Paper withBorder radius="md" p="lg" shadow="xs">
      <Stack gap="md">
        <Group gap="xs" align="center">
          {useIsValid === true && <CheckOrWarn bool={isValid} />}
          <Title order={3}>Generelt</Title>
        </Group>
        <Text size="sm" c="dimmed">
          Oppdater navn og status for denne enheten.
        </Text>
        <TitleWithValue
          title="Navn"
          value={board.name}
          editable
          saveCb={(oldValue, newValue) => saveCb(board, "name", oldValue, newValue)}
        />
        <DropdownEditDepricated
          title="Status"
          options={statuses.map((status) => status.label)}
          value={board.status}
          saveCb={(oldValue, newValue) =>
            saveCb(board, "status", oldValue, statuses.find((stat) => stat.label === newValue).value)
          }
          editable
          formatter={getLabel}
        />
        {startNow != null && (
          <div>
            <Button disabled={canStart} onClick={startNow}>
              Starta nu
            </Button>
          </div>
        )}
        {/*{hideAccess !== true && (
          <AccessHandlerEdit
            access={board.access}
            updateAccess={(oldValue, newValue) => saveCb(board, "access", oldValue, newValue)}
            allUsers={allUsers}
            createdByUserId={board.createdBy._id}
          />
        )}*/}
      </Stack>
    </Paper>
  );
};

export default GeneralSettingsCard;
